var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ app: true, 'modal-open': _vm.modalBlur },attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[(_vm.routes.some(function (ref) {
	var name = ref.name;

	return _vm.$route.name && _vm.$route.name === name;
}))?_c('Menu'):_vm._e(),(_vm.games)?_c('div',{staticClass:"pages"},[_c('router-view',{staticClass:"pages__wrapper"})],1):_vm._e(),(_vm.mobile && _vm.showModalMenu)?_c('ModalMenu'):_vm._e(),(_vm.error)?_c('ModalError'):_vm._e()],1),_c('portal-target',{attrs:{"name":"modalBlur"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }